/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import {styled} from '@mui/material/styles';

const Meter = styled('div')<{barHeight: number}>(({barHeight}) => ({
  position: 'relative',
  width: '100%',
  height: `${barHeight}px`,
  borderRadius: `${barHeight}px`,
  backgroundColor: '#dcdcdc',
}));

const Progress = styled('div')<{barHeight: number; color?: string}>(
  ({theme, barHeight, color}) => ({
    position: 'absolute',
    height: `${barHeight}px`,
    top: 0,
    left: 0,
    borderRadius: `${barHeight}px`,
    backgroundColor: color || theme.palette.primary.main,
    transition: 'all 500ms',
  })
);

// Progress is a number 0 - 1
export function ProgressBar({
  progress,
  barHeight,
  color,
}: {
  progress: number;
  barHeight?: number;
  color?: string;
}) {
  return (
    <Meter barHeight={barHeight || 7}>
      <Progress
        sx={{width: `${progress * 100}%`}}
        barHeight={barHeight || 7}
        color={color}
      />
    </Meter>
  );
}
